function createTimeoutPromise(timeout: number = 5000) : Promise<Response> {
  const timeoutBlob = new Blob(
    [ JSON.stringify({ error: 'Error: Timeout fetching user profile'})],
    { type: "application/json" }
  );

  return new Promise((resolve) => setTimeout(resolve, timeout, new Response(timeoutBlob, { status: 408 })));
}

export { createTimeoutPromise };
